import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import DateRangePicker from "react-bootstrap-daterangepicker";
import DashboardGraph from "../../components/Dashboard/DashboardGraph";
import DashboardMetrics from "../../components/Dashboard/DashboardMetrics";
import CopyRight from "../../components/CopyRight";
import Session from "../../utility/session";
import { loadDashboardDetails } from "../../Containers/Dashboard/actions";

// const mapStateToProps = state => ({
//   dashboardInfo: state.dashboardInfo
// });

class Dashboard extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.dispatch(loadDashboardDetails());
   
  }

  render() {
    return (
      <div>
        <div className="right_col" role="main">
          <DashboardMetrics />
          <DashboardGraph />
        </div>
      </div>
    );
  }
}

export default connect()(Dashboard);



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/index.js